import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CountryService, StateService } from '../../../_services/index';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

type StreetAddress = {
  street1:string;
  street2:string;
  city:string;
  state:string;
  zip:string;
}
@Component({
  selector: 'app-address-questiontype',
  templateUrl: './address.questiontype.component.html'
})
export class AddressQuestiontypeComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;

  validationMessages: any;
  value:StreetAddress;
  formSegment:FormGroup;
  getStateSub: Subscription;
  States:any;

  public getValue(){
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  constructor(
    public countryApi: CountryService,
    public stateApi: StateService
  ) {
      this.value={
        'street1':'',
        'street2':'',
        'city':'',
        'state':'',
        'zip':''
      };
  }

  get streetError():string {
    if(this.formSegment.controls['street1'].dirty || this.formSegment.controls['street1'].touched) {
      return !!this.formSegment.controls['street1'].errors ? 'Street address is required' : '';
    }
    return '';
  }
  get cityError():string {
    if(this.formSegment.controls['city'].dirty || this.formSegment.controls['city'].touched) {
      return !!this.formSegment.controls['city'].errors ? 'City is required' : '';
    }
    return '';
  }
  get stateError():string {
    if(this.formSegment.controls['state'].dirty || this.formSegment.controls['state'].touched) {
      return !!this.formSegment.controls['state'].errors ? 'State is required' : '';
    }
    return '';
  }
  get zipError():string {
    if(this.formSegment.controls['zip'].dirty || this.formSegment.controls['zip'].touched) {
      return !!this.formSegment.controls['zip'].errors ? 'ZIP code is required' : '';
    }
    return '';
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return (
      !this.formSegment.controls['street1'].errors
      && !this.formSegment.controls['city'].errors
      && !this.formSegment.controls['state'].errors
      && !this.formSegment.controls['zip'].errors
    );
  }
  validate():boolean {
    this.formSegment.controls['street1'].markAsTouched();
    this.formSegment.controls['city'].markAsTouched();
    this.formSegment.controls['state'].markAsTouched();
    this.formSegment.controls['zip'].markAsTouched();
    return this.isValid();
  }

  ngOnInit() {
    var i,init={};
    init['street1']=new FormControl('',[Validators.required]);
    init['street2']=new FormControl('');
    init['city']=new FormControl('',[Validators.required]);
    init['state']=new FormControl('',[Validators.required]);
    init['zip']=new FormControl('',[Validators.required]);

    this.formSegment=new FormGroup(init);

    if(this.value !== null) {
      for(i in init) {
				init[i].setValue(this.value[i]);
      }
    }

    this.getStateSub = this.stateApi.getStateList('US')
    .subscribe((dataResponse) => {
      this.States = dataResponse;
     });
  }

  ngOnDestroy() {
    if (this.getStateSub)  {
      this.getStateSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/address.questiontype.component.ts